export const trimTrailingSlashes = (str: string): string => {
    if (str.charAt(str.length - 1) === "/") {
        return trimTrailingSlashes(str.substr(0, str.length - 1));
    }

    return str;
};

export const trimLeadingSlashes = (str: string): string => {
    if (str.charAt(0) === "/") {
        return trimLeadingSlashes(str.substr(1));
    }

    return str;
};

/**
 * Sonarcloud was warning about a potentail DoS attack for a regex we had to do
 * this so I'm side stepping the problem by omitting regexes in the solution
 */
export const trimLeadingAndTrailingSlashes = (str: string): string => {
    return trimLeadingSlashes(trimTrailingSlashes(str));
};
